import {
	PROFILE_LOADING_STATUS,
	PROFILE_NOTES_GET,
	PROFILE_BOOKMARKS_GET,
	PROFILE_GET_ERROR,
	PROFILE_NOTES_UPDATE,
	PROFILE_EDITABLE_NOTE_UPDATE,
	PROFILE_NOTES_CLEAR,
	PROFILE_BOOKMARKS_CLEAR
} from './types'

const initialState = {
	loading: false,
	notes: [],
	notesMeta: null,
	bookmarks: [],
	bookmarksMeta: null,
	editableNote: null,
	errors: []
}

export const state = { ...initialState }

export default {
	[PROFILE_LOADING_STATUS]: (state, status) => {
		state.loading = status
	},

	[PROFILE_NOTES_GET]: (state, {
		data,
		pageCount,
		perPage,
		totalCount,
		currentPage
	}) => {
		state.notes = data
		state.notesMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage
		}
	},
	[PROFILE_BOOKMARKS_GET]: (state, {
		data,
		pageCount,
		perPage,
		totalCount,
		currentPage
	}) => {
		state.bookmarks = data
		state.bookmarksMeta = {
			pageCount,
			perPage,
			totalCount,
			currentPage
		}
	},

	[PROFILE_NOTES_UPDATE]: (state, payload) => {
		state.notes = [...state.notes.map(item => {
			if (item.users_follow_id === payload.users_follow_id) {
				return payload;
			}

			return item
		})]
	},

	[PROFILE_NOTES_CLEAR]: (state) => {
		state.notes = []
		state.notesMeta = null
	},

	[PROFILE_BOOKMARKS_CLEAR]: (state) => {
		state.bookmarks = []
		state.bookmarksMeta = null
	},

	[PROFILE_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[PROFILE_EDITABLE_NOTE_UPDATE]: (state, payload) => {
		state.editableNote = payload
	}
}
